/* Storefront query normalization. Stored and displayed SKUs are unchanged. */
(function (root) {
  'use strict';
  function canonical(value) {
    var raw = String(value || '').trim();
    // Do not rewrite text searches, Shopify operators, quotes or field queries.
    if (!/^[a-z0-9\s_./\\\-]+$/i.test(raw)) return null;
    var compact = raw.toUpperCase().replace(/[\s_./\\\-]+/g, '');
    var match;
    if ((match = /^LXM(\d{4})(XXXS|XXS|XS|S|M|L|XL|XXL|XXXL|[2-5]XL)?$/.exec(compact))) {
      return 'LXM_' + match[1] + (match[2] ? '_' + match[2] : '');
    }
    if ((match = /^LXA(\d{4})([A-Z])?(\d{1,2})?$/.exec(compact))) {
      return 'LXA_' + match[1] + (match[2] || '') + (match[3] ? '-' + match[3] : '');
    }
    if ((match = /^(LX|SP)([A-Z]{0,3}\d{1,5}[A-Z]?)$/.exec(compact))) {
      return match[1] + '_' + match[2];
    }
    if (/^PJ\d{5}$/.test(compact)) return compact;
    return null;
  }
  function query(value) {
    var digits = String(value || '').trim();
    if (/^\d{1,5}$/.test(digits)) {
      var prefixes = ['LX_', 'SP_', 'LXM_', 'LXA_', 'LX_MK', 'LX_VB', 'SP_CWL', 'SP_SS', 'SP_ST', 'SP_L', 'PJ'];
      // Model number or its beginning; wildcard includes size/color suffixes.
      return digits + prefixes.map(function (prefix) {
        return ' OR variants.sku:' + prefix + digits + '*';
      }).join('');
    }
    return canonical(value) || value;
  }
  var api = { canonical: canonical, query: query };
  root.BSSku = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof document === 'undefined') return;

  // Keep native form submission, locale paths and all other form fields intact.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[action]')) return;
    var action = new URL(form.action, window.location.href);
    var search = new URL(window.routes.searchUrl, window.location.origin);
    if (action.origin !== search.origin || action.pathname !== search.pathname) return;
    var input = form.querySelector('[name="q"]');
    if (!input) return;
    var original = input.value;
    input.value = query(original);
    // Browser serializes the form before this timer; retain the user's text on return.
    setTimeout(function () { input.value = original; }, 0);
  }, true);

  // Also support bookmarked/shared /search?q=LX2815 URLs. One canonical redirect only.
  var url = new URL(window.location.href);
  var searchUrl = new URL(window.routes.searchUrl, window.location.origin);
  if (url.pathname === searchUrl.pathname && !url.searchParams.has('section_id')) {
    var term = url.searchParams.get('q');
    var normalized = query(term);
    if (normalized && normalized !== term) {
      url.searchParams.set('q', normalized);
      window.location.replace(url.href);
    }
  }
})(typeof window === 'undefined' ? globalThis : window);
